import { render, staticRenderFns } from "./AddonServices.vue?vue&type=template&id=67f8f9d4&scoped=true"
import script from "./AddonServices.vue?vue&type=script&lang=js"
export * from "./AddonServices.vue?vue&type=script&lang=js"
import style0 from "./AddonServices.vue?vue&type=style&index=0&id=67f8f9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8f9d4",
  null
  
)

export default component.exports